export var OTHER_TYPE = "other";